


































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import LayoutModule from '../../store/layout';
import DocumentUploadModule from '~/store/documentUpload';
import EnrollmentModule from '~/store/enrollment';
import EligibilityModule from '~/store/eligibility';
// import ConfigurationDrawer from '~/components/configuration/ConfigurationDrawer.vue';
@Component<Header>({

    layout: 'default',
    icons: {
        faArrowRight,
    },
    components: {
        // ConfigurationDrawer,
    },
})
export default class Header extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve 
    uploadModule!: DocumentUploadModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Resolve
    public eligibility!: EligibilityModule;

    public mobileMenuOpen = false;
    public activeDesktopTab: 'home' | 'returningUser' | 'voucherLookup' | null = 'home';


    // public get drawer() {
    //     return this.layout.drawer;
    // }
    // public set drawer(v) {
    //     this.layout.setDrawer(v);
    // }

    public get headerLogoSrc() {
        return this.$settings.url(this.$settings.headerLogo);
    }
    public get openMenuIconSrc() {
        return this.$settings.url(this.$settings.menu);
    }
    public get closeMenuIconSrc() {
        return this.$settings.url(this.$settings.vector);
    }
    public get bodyImageSrc() {
        return this.$settings.url(this.$settings.bodyImage);
    }
    public get PatternBgMobile() {
        return this.$settings.url(this.$settings.PatternBgMobile);
    }
    public get landingPageHeaderArrowSrc() {
        return this.$settings.url(this.$settings.landingPageHeaderArrow);
    }
    public get chevronImageSrc() {
        return this.$settings.url(this.$settings.chevronImage);
    }
    public get centerLogoSrc() {
        return this.$settings.url(this.$settings.centerLogo);
    }
    public get centerBGImageSrc() {
        return this.$settings.url(this.$settings.centerBGImage);
    }
    public get vectorImageSrc() {
        return this.$settings.url(this.$settings.plusVector);
    }
    public get CheckVectorImage() {
        return this.$settings.url(this.$settings.IconRight);
    }
    public get ImageRightCheck() {
        return this.$settings.url(this.$settings.Icon_Right_Check);
    }
    public get crossVectorImage() {
        return this.$settings.url(this.$settings.unsuccessful);
    }

    public get error_page_icon() {
        return this.$settings.url(this.$settings.error_page_icon);
    }

    public get shouldShowSplashPage(): boolean {
        return this.$settings.shouldShowSplashPage === 'true' || this.layout.shouldShowSplashPage;
    }

    public get isLandingPage(): boolean {
        return this.$route.name === 'index';
    }

    // public get isAbsolute() {
    //     return this.layout.configuration.logoPosition !== 'start';
    // }

    // public get isScrolling() {
    //     return this.layout.configuration.headerStyle === 'scrolling';
    // }
    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }

    handleClick() {
        this.$vuetify.goTo('#main-footer', {
            duration: 1000,
            easing: 'easeInOutCubic',
            offset: 70,
        });
    }

    public toggleMobileMenu(forceState?: boolean) {
        this.mobileMenuOpen = typeof forceState === 'boolean' ? forceState : !this.mobileMenuOpen;
    }

    @Watch('$vuetify.breakpoint.width')
    onBreakpointWidthChange(width: number) {
        if (width > 768 && this.mobileMenuOpen) {
            this.mobileMenuOpen = false;
        }
    }
    
    // @Watch('$route.path', { immediate: true })
    // onRouteChange(path: string) {
    //     if (path === '/') {
    //         this.activeDesktopTab = 'home';
    //     } else if (path === '/returning-user') {
    //         this.activeDesktopTab = 'returningUser';
    //     } else if (path === '/voucher-lookup' || path === '/voucher-not-found') {
    //         this.activeDesktopTab = 'voucherLookup';
    //     } else {
    //         this.activeDesktopTab = null;
    //     }
    // }

    @Watch('$route.name', { immediate: true })
    onRouteChange(name: string) {
        if (name === 'voucher-lookup' || name === 'voucher-not-found' || name === 'voucher-success') {
            this.activeDesktopTab = 'voucherLookup';
        } else if (name === 'returning-user') {
            this.activeDesktopTab = 'returningUser';
        } else if (name === 'index') {
            this.activeDesktopTab = 'home';
        } else {
            this.activeDesktopTab = null;
        }
    }
    public storeClear(){
        setTimeout(() => {
            this.enrollment.clearStore();
            this.uploadModule.clearStore();
            this.eligibility.clearStore();
        }, 70);
    }

    public handleMobileApplyClick() {
        this.toggleMobileMenu(false);
        this.storeClear();
        if (this.$route.path !== '/enroll/eligibility') {
            this.$router.push('/enroll/eligibility');
        }
    }

    public handleDesktopApplyClick() {
        this.storeClear();
        if (this.$route.path !== '/enroll/eligibility') {
            this.$router.push('/enroll/eligibility');
        }
    }

    public setActiveDesktopTab(tab: 'home' | 'returningUser' | 'voucherLookup') {
        this.activeDesktopTab = tab;
    }

    public setActiveTab(tab: 'home' | 'returningUser' | 'voucherLookup') {
        this.setActiveDesktopTab(tab);
        this.storeClear();
        if (tab === 'returningUser' && this.$route.path !== '/returning-user') {
            this.$router.push('/returning-user');
        } else if (tab === 'home' && this.$route.path !== '/') {
            this.$router.push('/');
        } else if (tab === 'voucherLookup' && this.$route.path !== '/voucher-lookup') {
            this.$router.push('/voucher-lookup');
        }
    }
}
